import { useFileUpload } from "@/react/components/Spaces/CourseSpace/Lessons/Edit/hooks/useFileUpload";
import { UploadingFile } from "@/react/components/Spaces/CourseSpace/Shared/LessonFile/UploadingFile";
import { Loader } from "@circle-react-uikit/Loader";
import { Content } from "./Content";
import { Header } from "./Header";

export const FilesTab = () => {
  const {
    files,
    meta,
    progress,
    completedUploads,
    isLoading,
    isUploading,
    isAddingFile,
    handleUpload,
  } = useFileUpload();

  if (isLoading) {
    return <Loader center />;
  }

  return (
    <>
      <Header
        files={files}
        isUploading={isUploading}
        handleUpload={handleUpload}
        meta={meta}
      />
      <Content files={files} completedUploads={completedUploads} />
      {(isUploading || isAddingFile) && (
        <UploadingFile progress={progress} isIndeterminate={isAddingFile} />
      )}
    </>
  );
};
